import React from "react";
import { PhoneDisplay } from "@/components/PhoneDisplay";

const ND = <span className="text-muted-foreground/70" title="Non indicato">n.d.</span>;
const val = (v) => (v && String(v).trim()) || null;
const place = (d, p = "") => {
  const city = [val(d[`${p}zip`]), val(d[`${p}city`]), val(d[`${p}province`]) && `(${d[`${p}province`]})`].filter(Boolean).join(" ");
  return [val(d[`${p}address`]), city, !p && val(d.country)].filter(Boolean).join(" · ") || null;
};
const SOCIAL = [["website", "Sito"], ["facebook", "Facebook"], ["instagram", "Instagram"], ["linkedin", "LinkedIn"], ["youtube", "YouTube"], ["whatsapp", "WhatsApp"]];

const Row = ({ k, label, children }) => <div className="flex items-baseline gap-3 min-w-0" data-testid={`linked-profile-field-${k}`}>
  <dt className="w-28 shrink-0 text-xs text-muted-foreground">{label}</dt><dd className="text-sm min-w-0 break-words">{children}</dd>
</div>;
const Text = ({ v }) => val(v) || ND;
const Phone = ({ v, k }) => (val(v) ? <PhoneDisplay value={v} fallback="n.d." data-testid={`linked-profile-phone-${k}`} /> : ND);
const Card = ({ i, title, children }) => <section className="rounded-xl border border-border bg-card p-4" data-testid={`linked-profile-section-${i}`}>
  <h2 className="font-head text-base font-semibold mb-2.5">{title}</h2><dl className="space-y-1.5">{children}</dl>
</section>;

export const ProfileSummary = ({ data: d }) => {
  const socials = SOCIAL.filter(([k]) => val(d[k]));
  return <div className="grid md:grid-cols-2 gap-4" data-testid="linked-profile-summary">
    <Card i={0} title="Anagrafica e contatti">
      <Row k="name" label="Referente"><Text v={d.name} /></Row>
      <Row k="company_name" label="Ragione sociale"><Text v={d.company_name} /></Row>
      <Row k="phone" label="Telefono"><Phone v={d.phone} k="phone" /></Row>
      <Row k="contact_email" label="Email"><Text v={d.contact_email} /></Row>
    </Card>
    <Card i={1} title="Fatturazione e dati fiscali">
      <Row k="address" label="Sede legale">{place(d) || ND}</Row>
      <Row k="vat_number" label="P.IVA"><Text v={d.vat_number} /></Row>
      <Row k="fiscal_code" label="C.F."><Text v={d.fiscal_code} /></Row>
      <Row k="pec" label="PEC"><Text v={d.pec} /></Row>
      <Row k="sdi" label="SDI"><Text v={d.sdi} /></Row>
    </Card>
    <Card i={2} title="Spedizione">
      {d.shipping_same !== false ? <Row k="shipping_same" label="Indirizzo">Uguale alla fatturazione</Row> : <>
        <Row k="shipping_name" label="Destinatario"><Text v={d.shipping_name} /></Row>
        <Row k="shipping_address" label="Indirizzo">{place(d, "shipping_") || ND}</Row>
        <Row k="shipping_phone" label="Telefono"><Phone v={d.shipping_phone} k="shipping_phone" /></Row>
      </>}
      {val(d.operating_address) && <Row k="operating_address" label="Sede operativa">{d.operating_address}</Row>}
    </Card>
    <Card i={3} title="Sito e social privati">
      {socials.length ? socials.map(([k, label]) => <Row key={k} k={k} label={label}>{k === "whatsapp" ? <Phone v={d[k]} k={k} /> : <span className="break-all">{d[k]}</span>}</Row>)
        : <p className="text-sm text-muted-foreground" data-testid="linked-profile-social-empty">Nessun sito o social indicato</p>}
    </Card>
  </div>;
};
